import { useContext, useEffect, useState } from "react";

import { Context } from "../Provider";
import { checkFtmDocuments, fetchDocumentTypeslist } from "../service";
import { theme } from "../../theme";
import DivSpinner from "../../common/DivSpinner";
import BtnSpinner from "../../common/BtnSpinner";
import FileAndUploader from "./uploadedCertificates/documents/FileAndUploader";
import CardTemplate from "../../common/CardTemplate";
import useIsMobile from "../../common/hooks/useIsMobile";
import ReviewNote from "./reviewNote/ReviewNote";

const UploadedDocuments = () => {
    const { state, updateCurrentStep } = useContext(Context);
    const { ftm, step } = state;

    const [openFileUploadModal, setOpenFileUploadModal] = useState(false);
    const [selectedDocumentType, setSelectedDocumentType] = useState(null);
    const [loadingNext, setLoadingNext] = useState(false);
    const [refreshCounter, setRefreshCounter] = useState(0);

    const [details, setDetails] = useState({
        loading: true,
        types: [],
    });
    const isMobile = useIsMobile();

    useEffect(() => {
        const getDocumentTypes = async () => {
            try {
                const response = await fetchDocumentTypeslist(ftm?.ftm_id);
                if (response?.status === "Success") {
                    setDetails({
                        loading: false,
                        types: response.types,
                    });
                } else {
                    setDetails({
                        loading: false,
                        types: [],
                    });
                }
            } catch (error) {
                console.error("Error getting document types:", error);
                setDetails({
                    loading: false,
                    types: [],
                });
            }
        };

        if (step.stepId > 5) {
            getDocumentTypes();
        }
    }, [ftm?.ftm_id, step, refreshCounter]);

    const handleRefresh = () => setRefreshCounter((prev) => prev + 1);

    const handleOpenFileUploadModal = (docType) => {
        setSelectedDocumentType(docType);
        setOpenFileUploadModal(true);
    };

    const handleCloseFileUploadModal = () => {
        setOpenFileUploadModal(false);
    };

    const Loading = () => (
        <div style={{ height: `${window.innerHeight - 387}px` }}>
            <DivSpinner />
        </div>
    );

    const handleNext = async () => {
        try {
            setLoadingNext(true);
            const response = await checkFtmDocuments(ftm?.ftm_id);
            if (response?.status === "Success") {
                updateCurrentStep(8);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoadingNext(false);
        }
    };

    const handleNextItem = (id) => {
        const index = details.types.findIndex(item => item.personal_document_type_id === id);
        if (index !== -1 && index < details.types.length - 1) {
            setSelectedDocumentType(details.types[index + 1]);
        }
    };

    const handlePrevItem = (id) => {
        const index = details.types.findIndex(item => item.personal_document_type_id === id);
        if (index > 0) {
            setSelectedDocumentType(details.types[index - 1]);
        }
    };

    return (
        <CardTemplate
            stepId={8}
            currentStep={step?.stepId}
            // extraButtonComponet={
            //     <>
            //         {step.stepId === 7 && (
            //             <button
            //                 className={`btn btn-${theme.main} btn-sm`}
            //                 onClick={handleNext}
            //                 disabled={loadingNext}
            //             >
            //                 {loadingNext ? <BtnSpinner /> : "COMPLETED"}
            //             </button>
            //         )}
            //     </>
            // }
            body={
                <>
                    {details.loading ? <Loading /> : (
                        <>
                            <ul className="list-group">
                                {details.types.map((item, index) => (
                                    <li
                                        className="list-group-item list-group-item-action border-0 d-flex justify-content-between border-radius-0-2 cursor-pointer"
                                        key={index}
                                        onClick={() => handleOpenFileUploadModal(item)}
                                    >
                                        <div className="d-flex flex-column">
                                            <h6 className="mb-1 text-dark font-weight-bold text-lg">
                                                <i className={`material-icons opacity-10 text-${theme.main} me-2`}>
                                                    {item.personal_document_type_icon}
                                                </i>
                                                {item.personal_document_type_name}

                                                {item.already_uploaded_personal_document && (
                                                    <i className={`material-icons text-sm opacity-10 text-${theme.main} ms-2`}>
                                                        check_circle
                                                    </i>
                                                )}
                                            </h6>
                                            <span className="text-xs">
                                                {item.personal_document_type_description}
                                            </span>
                                        </div>
                                        <div className="d-flex align-items-center text-sm">
                                            {item.already_uploaded_personal_document ? (
                                                <i className={`material-icons opacity-10 text-${theme.main} ms-2`}>
                                                    check_circle
                                                </i>
                                            ) : (
                                                <i className={`material-icons opacity-10 ms-2`}>
                                                    add_circle
                                                </i>
                                            )}
                                        </div>
                                    </li>
                                ))}
                            </ul>

                            <ReviewNote />

                            {step.stepId === 7 && (
                                <div className="mt-3 text-end">
                                    <button
                                        className={`btn btn-${theme.main} btn-sm ${isMobile && 'w-100'}`}
                                        onClick={handleNext}
                                        disabled={loadingNext}
                                    >
                                        {loadingNext ? <BtnSpinner /> : "COMPLETE"}
                                    </button>
                                </div>
                            )}
                        </>
                    )}

                    <FileAndUploader
                        ftm_id={ftm?.ftm_id}
                        item={selectedDocumentType}
                        items={details?.types}
                        show={openFileUploadModal}
                        handleClose={handleCloseFileUploadModal}
                        type="documents"
                        parentRefresh={handleRefresh}
                        handleNextItem={handleNextItem}
                        handlePrevItem={handlePrevItem}
                    />
                </>
            }
        />
    );
};

export default UploadedDocuments;